import React from 'react';
import classnames from 'classnames';
import styles from './searchActivityTab.module.scss';
import { SearchEntity } from 'v2/models';
import InfiniteScroll from 'v2/common/InfiniteScroll/InfiniteScroll';
import { SearchActivityItem } from './ActivityItems/SearchActivityItem';
import NoAssociationsPlaceholder from '../NoAssociationsPlaceholder/NoAssociationsPlaceholder';
import { useInfiniteSearchActivities } from 'v2/queries/useInfiniteSearchActivities';

export interface ActivityTabProps {
  search: SearchEntity;
}

const SearchActivityTab = ({ search }: ActivityTabProps) => {
  const { data, isFetching, fetchNextPage, hasNextPage } =
    useInfiniteSearchActivities(search.id);

  if (!data) {
    return null;
  }

  if (data.pages[0].count === 0) {
    return <NoAssociationsPlaceholder />;
  }

  return (
    <>
      <div className={classnames(styles.activityListContainer)}>
        {data.pages.map((page, pageIndex) => (
          <React.Fragment key={page.next}>
            {page.count > 0 && (
              <>
                {page.results.map((activity, activityIndex) => {
                  const isFirstItem = pageIndex === 0 && activityIndex === 0;
                  return (
                    <SearchActivityItem
                      key={activity.id}
                      activity={activity}
                      search={search}
                      isFirstItem={isFirstItem}
                    />
                  );
                })}
              </>
            )}
          </React.Fragment>
        ))}
      </div>
      <InfiniteScroll
        callback={() => fetchNextPage()}
        isLoading={isFetching}
        disabled={!hasNextPage}
        scrollThreshold={500}
      />
    </>
  );
};

export default SearchActivityTab;
